import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SizeFieldWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SizeButton = styled.button`
  width: 45%;
  @media (max-width: 768px) {
    width: auto;
  }
`

const SmartMark = ({ onClick }) => (

  <div className='b-rit-smart-mark__wrapper'>
    <SizeFieldWrapper>
      <p className='b-rit-smart-mark__header'>
        УМНАЯ МЕРКА
    </p>
      <span className='b-rit-smart-mark__bage'>
        Выбор покупателей
    </span>
    </SizeFieldWrapper>
    <p className='b-rit-smart-mark__body'>
      Мы проанализировали сотни тысяч типовых
      мерок и нашли общие показатели, зависящие именно
      от веса, роста и обхвата шеи. Если Вы сомневаетесь в
      правильности автоматически рассчитанных мерок,
      Вы всегда можете перепроверить и подкорректировать
      полученный результат.
    </p>
    <SizeButton
        className='rit-button rit-button_theme_black rit-button_size_30em'
        onClick={onClick}
      >
        СНЯТЬ РАЗМЕРЫ
    </SizeButton>
  </div>
)

SmartMark.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default SmartMark;